<template>
    <!-- 评分详情 -->
    <el-dialog title="主观题评分详情" v-if="dialogVisible" :visible.sync="dialogVisible" width="500px" @close="close"
               :close-on-click-modal="false" :close-on-press-escape="false">
        <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                  element-loading-spinner="el-icon-loading" ref="multipleTable"
                  stripe size="medium" style="width:100%">
            <el-table-column prop="number" :label="reprintTextConfig.number">
                <template slot-scope="scope">{{ scope.row.reviewer.questionSort }}</template>
            </el-table-column>
            <el-table-column :label="reprintTextConfig.teacherId">
                <template slot-scope="scope">{{ findTeacherName(scope.row.reviewer.teacherId) }}</template>
            </el-table-column>
            <el-table-column prop="score" :label="reprintTextConfig.score"></el-table-column>
            <el-table-column v-if="isPrivilegedMode" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button
                        slot="reference"
                        v-hasPermi="['review:result:list']"
                        plain
                        type="primary"
                        size="mini" @click="modifyScore(scope.row, `btn_${scope.row.reviewer.questionId}_${scope.row.reviewer.teacherId}`)" :ref="`btn_${scope.row.reviewer.questionId}_${scope.row.reviewer.teacherId}`">修改</el-button>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">关闭</el-button>
        </span>
        <el-popover
                v-if="showPop"
                ref="pop"
                :reference="reference"
                placement="top"
                width="300"
                :visible-arrow="false">
            <el-form :model="form" ref="form" size="mini">
                <el-form-item
                        v-for="(item, index) in form.scores"
                        :label="item.label"
                        :rules="[
                                        { required: true, message: '请输入评分', trigger: 'blur' },
                                        { type: 'number', min: 0, max: item.max, message: `评分必须在 0 到 ${item.max}之间`, trigger: 'blur' }
                                    ]"
                        :prop="'scores.' + index + '.score'">
                    <el-input v-model.number="item.score"></el-input>
                    <span class="question-score">{{ item.max }}分</span>
                </el-form-item>
                <el-form-item>
                    <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="cancel">取消</el-button>
                    <el-button type="primary" size="mini" :disabled="pending" @click="submitForm">确定</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-popover>
    </el-dialog>
</template>
<script>
    import {getExamPaper} from "@/api/arrangement";
    import {updateScore} from "@/api/reviewResult";

    export default {
        props: ['row', 'show'],
        data() {
            return {
                loading: true,
                dialogVisible: false,
                tableData: [],
                teacherList: [],
                questionList: [],
                questionType: "subjectivity",
                question: null,
                form: {
                    scores: []
                },
                pending: false,
                reference: {},
                showPop: false,
                currentItem: null,
            };
        },
        computed: {
            reprintTextConfig() {
                return this.$store.state.global.textConfig.backend.examineeScore.table.button.reprint
            },
            isPrivilegedMode() {
                return sessionStorage.getItem('privilege') === 'true'
            }
        },
        mounted() {
          this.getExamPaper()
        },
        watch: {
            show() {
                this.dialogVisible = this.show;
                this.loading = true
                this.selectRow = []
                if (this.show) {
                    this.$store.dispatch('getReviewer', this.row).then(res => {
                        if (res.status === 200) {
                            this.loading = false
                            this.tableData = res.data
                        }
                    })
                    this.teacherList = this.$store.state.reviewTeacherList.list
                }
            },
        },
        methods: {
            findTeacherName(id) {
                let obj = {}
                obj = this.teacherList.find(item => {
                    return item.teacherId == id
                })
                if (obj) {
                    return obj.teacherName
                }
            },
            close() {
                this.dialogVisible = false
                this.$emit('close', false, true)
            },
            async getExamPaper() {
                const cache = localStorage.getItem('setExamineeScoreInfo')
                if (cache) {
                    let scoreInfo = JSON.parse(cache)
                    if (scoreInfo.examPaperId) {
                        const res = await getExamPaper(scoreInfo.examPaperId)
                        const item = res.data.confirmed_paper.find(x => x.question_type === this.questionType)
                        if (item) {
                            this.questionList = item.question_list
                        }
                    }
                }
            },
            modifyScore(item, ref) {
                if (this.currentItem === item && this.showPop) {
                    return
                }
                const questionId = item.reviewer.questionId
                this.currentItem = item
                this.showPop = false

                this.form.scores = []
                this.form.id = item.id
                this.visible = true
                this.question = this.questionList.find(q => q.id === questionId)
                if (this.question.crosshead && this.question.crosshead.length > 1) {
                    this.question.crosshead.forEach((sub, index) => {
                        this.form.scores.push({
                            questionId: questionId,
                            score: null,
                            subId: index,
                            max: sub.score,
                            label: `小题${index+1}`
                        })
                    })
                } else {
                    this.form.scores.push({
                        questionId: questionId,
                        score: null,
                        max: this.question.score,
                        label: '得分'
                    })
                }

                this.reference = this.$refs[ref].$el
                this.$nextTick(() => {
                    // 等待显示的popover销毁后再 重新渲染新的popover
                    this.showPop = true
                    this.$nextTick(() => {
                        // 此时才能获取refs引用
                        this.$refs.pop.doShow()
                    })
                })
            },
            cancel() {
                this.$refs.pop.doClose()
            },
            submitForm() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.pending = true;
                        const data = {
                            id: this.form.id,
                            score: this.form.scores.map(item => item.score),
                            comment: null
                        }
                        updateScore(data).then(res => {
                            this.pending = false
                            this.currentItem.score = data.score.reduce((acc, curr) => acc + curr, 0)
                            if (res.status === 200) {
                                this.cancel()
                            }
                        }).catch(() => {
                            this.pending = false
                        })
                    }
                });
            }
        }
    }
</script>
<style scoped>
    /deep/ .el-input {
        width: 170px;
    }
    .question-score {
        margin-left: 5px;
    }
</style>
